import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { useI18n } from '../../../../application/language/useI18n';

interface Props {
  finalResultsVerbose: {
    title: string;
    subtitle: string;
  };
  maximumScore?: number;
  correctQuizAnswersCount?: number;
  correctPracticeAnswersCount?: number;
  correctQuizMaximumScore?: number;
  correctPracticeMaximumScore?: number;
  totalUnitResult: number;
}

export const FinalResultsVerbose = observer(
  ({
    finalResultsVerbose,
    maximumScore,
    correctQuizAnswersCount,
    correctPracticeAnswersCount,
    correctQuizMaximumScore,
    correctPracticeMaximumScore,
    totalUnitResult,
  }: Props) => {
    const { translate } = useI18n();
    const classes = useStyles();

    return (
      <div className={classes.resultsVerboseContainer}>
        <Typography className={classes.resultsVerboseTitle} variant={'h3'}>
          {finalResultsVerbose?.title}
        </Typography>
        <Typography variant={'h5'}>
          {translate('passing.correctAnswersQuizCount')}: {correctQuizAnswersCount}{' '}
          {translate('phrases.of')?.toLowerCase()} {correctQuizMaximumScore}
        </Typography>
        <Typography variant={'h5'}>
          {translate('passing.correctAnswersPracticeCount')}: {correctPracticeAnswersCount}{' '}
          {translate('phrases.of')?.toLowerCase()} {correctPracticeMaximumScore}
        </Typography>
        <Typography variant={'h5'}>
          {translate('passing.correctAnswersTotalCount')}: {Math.round(totalUnitResult)}{' '}
          {translate('phrases.of')?.toLowerCase()} {maximumScore}
        </Typography>
        <p>{finalResultsVerbose?.subtitle}</p>
      </div>
    );
  },
);

const useStyles = makeStyles(() => ({
  resultsVerboseContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  resultsVerboseTitle: {
    marginBottom: '16px',
  },
}));
